import BottomActionQr from 'components/BottomActionQr';
import Pageheader from 'components/Pageheader';
import React, { useEffect, useState, useContext } from 'react';
import ModalContext from 'contexts/ModalContext';
import { Helmet } from "react-helmet";
import { useNavigate, useSearchParams } from 'react-router-dom';
import QRCode from 'qrcode.react';
import Barcode from 'react-barcode';
import { GetRedeemCoupon } from 'services/Api/Module/Coupon';
import CountdownTimer from 'components/CountdownTimer';
import useTranslations from 'i18n/useTranslations';
import PullToRefresh from 'components/pullToRefresh/PullToRefresh';
import moment from 'moment';

const CouponQr = () => {
    let [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const [refreshing, setRefreshing] = useState(false)
    const { lang, supportedLangs, setLang } = useTranslations(); // สำหรับเปลี่ยนภาษา
    const { t } = useTranslations();
    const brandId = searchParams.get('restaurantId');
    const branchId = searchParams.get('branchId');
    const redeemId = searchParams.get('id');
    const fromPage = searchParams.get('fromPage');
    const { mAlert } = useContext(ModalContext);
    const [redeemCoupon, setRedeemCoupon] = useState({});
    const fetchGetRedeemCoupon = async (payload) => {
        try {
            const response = await GetRedeemCoupon({ params: payload });
            const resData = response?.data;
            if (resData.resultCode === 20000) {
                setRedeemCoupon(resData.resultData[0]);
            } else {
                mAlert.info({
                    title: "ไม่พบ coupon",
                    subTitle: "ไม่พบ coupon",
                    content: "",
                    onClose: () => { },
                });
            }
            setRefreshing(false)
        } catch (err) {
            setRefreshing(false)
            console.log('err ', err);
            mAlert.info({
                title: "แจ้งเตือน",
                subTitle: "มีบางอย่างผิดพลาด",
                content: "",
                onClose: () => { },
            });
        }
    };
    const handleCancel = () => {
        if (fromPage) {
            navigate(`/${fromPage}`)
        } else {
            mAlert.info({
                title: t.couponQR.cancel,
                subTitle: `${t.couponQR.cancelBody1}  <br/> ${t.couponQR.cancelBody2} `,
                type: "confrim",
                mode: "red",
                content: "",
                onClose: () => { },
                onYes: () => { handleOk() },
                onNo: () => { console.log('SAY NO') },
            })
        }
        
    }
    const handleOk = () => {
        if (fromPage) {
            navigate(`/${fromPage}`)
        } else {
            navigate(`/coupon-all?restaurantId=${brandId}&branchId=${branchId}`)
        }
    }
    const handleRefresh = () => {
        console.log('handleRefresh!!!')
        setRefreshing(true)
        onLoad();
    }
    const onLoad = () => {
        let payload = {
            id: redeemId
        }
        fetchGetRedeemCoupon(payload);
    }

    const checkExpire = (expireDateTime) => {
        const targetDate = expireDateTime ? moment(expireDateTime) : moment()
        const now = moment(); // สร้างเวลาปัจจุบันใน UTC+0
        const nowMinus7Hours = now.subtract(7, 'hours');
        const timeDifference = moment.duration(targetDate.diff(nowMinus7Hours));
        console.log(timeDifference)
        if (timeDifference.asMilliseconds() <= 0) {
            return true
        }
        return false
    }
    useEffect(() => {
        onLoad();
    }, [])

    const isExpire = checkExpire(redeemCoupon?.expiredAt)
    const isUsed = redeemCoupon?.isUsed === 1
    let labelAlert = ''

    if (isUsed) {
        labelAlert = t.couponQR.usedCoupon
    } else if (isExpire) {
        labelAlert = t.couponQR.expiredCoupon
    }

    return (
        <>
            <PullToRefresh
                refreshing={refreshing}
                onRefresh={handleRefresh}
            >
                <Helmet>
                    <title>IMPACT Family</title>
                    <meta name="title" content="Impact Family" />
                    <meta name="description" content="Impact Family" />
                    <meta name="keyword" content="" />
                    <meta property="og:title" content="Impact Family" />
                    <meta property="og:description" content="Impact Family" />
                    <meta property="og:image" content="" />
                    <meta property="og:url" content="" />
                    <meta property="og:type" content="website" />
                    <meta property="og:site_name" content="Impact Family" />
                </Helmet>
                <div id="pageQR-coupon">

                    <Pageheader pagename={t.couponQR.title} onClick={handleCancel} />
                    <main id="top">
                        <div className="wrapContent">
                            <section id="pQR">
                                <div className="bQR">
                                    <h2>{redeemCoupon?.couponName}</h2>
                                    <div class={`bGroup ${isExpire || isUsed ? 'expire' :''}`}>
                                        <p>{t.collectPoint.show}</p>
                                        <div className="bPic">
                                            <QRCode value={redeemCoupon?.couponCode} size={145} />
                                            {/* <img src="https://dummyimage.com/145x145/667085/fff" /> */}
                                        </div>
                                        <div className="bMembercode">
                                            <p>{t.collectPoint.code} <span>{redeemCoupon?.couponCode}</span></p>
                                        </div>
                                        <Barcode
                                            value={redeemCoupon?.couponCode}
                                            format="CODE128"
                                            width={2}
                                            height={100}
                                            displayValue={false}
                                            background="#ffffff"
                                            lineColor="#000000"
                                        />
                                        <div className="bCountTime">
                                            {t.couponQR.expired} <span id="timer"><CountdownTimer expireDateTime={redeemCoupon?.expiredAt} onExpire={() => console.log("OTP expire")} /></span> 
                                        </div>
                                        <BottomActionQr isFormComplete={true} handleBack={handleCancel} handleOk={handleOk} classBtn1="hide"/>
                                        <div className="bExpire"><p>{labelAlert}</p></div>
                                    </div>
                                </div>
                            </section>


                        </div>
                    </main>

                </div>
            </PullToRefresh>
        </>
    )
}

export default CouponQr